import { useCallback } from 'react';

import { clientSdk } from '../ClientSDK';

export const useInitialParams = () => {
  const getInitialParams = useCallback(clientSdk.getInitialParams, []);
  return { getInitialParams };
};
